import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative border border-gray-400 rounded-xl h-84 w-100 bg-white" }
const _hoisted_2 = { class: "absolute -top-10 left-40 p-3.5 h-20 w-20 mx-auto bg-primary-800 rounded-full flex items-center justify-center" }
const _hoisted_3 = { class: "flex h-full w-full px-4" }
const _hoisted_4 = { class: "space-y-1" }
const _hoisted_5 = { class: "flex items-center mt-2" }
const _hoisted_6 = { class: "flex items-center gap-2 text-sm text-gray-500 cursor-pointer select-none" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-error-500 mt-2"
}
const _hoisted_8 = { class: "mt-auto w-full" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { LogIn } from 'lucide-vue-next';
import AppInput from '@/components/ui/AppInput.vue';
import AppButton from '@/components/ui/AppButton.vue';
import Authentication from '@/plugins/authentication';


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const form = reactive({ email: '', password: '', remember: true });
const errors = reactive({ email: '', password: '', general: '' });
const loading = ref(false);

async function onSubmit() {
    errors.email = '';
    errors.password = '';
    errors.general = '';

    if (!form.email) { errors.email = t('auth.login.required'); return; }
    if (!form.password) { errors.password = t('auth.login.required'); return; }

    loading.value = true;
    try {
        await Authentication.login({ email: form.email, password: form.password, remember: form.remember });
        router.push('/account/profile');
    } catch {
        errors.general = t('auth.login.invalidCredentials');
    } finally {
        loading.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(LogIn), { class: "w-9 h-9 text-white" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "pt-20 pb-4 w-full flex flex-col",
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AppInput, {
            modelValue: form.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
            label: _ctx.$t('auth.login.email'),
            type: "email",
            autocomplete: "email",
            error: errors.email,
            onSubmit: onSubmit
          }, null, 8, ["modelValue", "label", "error"]),
          _createVNode(AppInput, {
            modelValue: form.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
            label: _ctx.$t('auth.login.password'),
            type: "password",
            autocomplete: "current-password",
            error: errors.password,
            onSubmit: onSubmit
          }, null, 8, ["modelValue", "label", "error"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.remember) = $event)),
              type: "checkbox",
              class: "rounded"
            }, null, 512), [
              [_vModelCheckbox, form.remember]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('auth.login.rememberMe')), 1)
          ])
        ]),
        (errors.general)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.general), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(AppButton, {
            loading: loading.value,
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('auth.login.submit')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32)
    ])
  ]))
}
}

})